import { API } from '../Api';

export interface ClanMessage {
  id: string;
  clanId: string;
  senderUserId: string;
  senderName?: string;
  senderAvatar?: string;
  content: string;
  createdAt: string;
}

// Lịch sử chat của 1 bang (BE trả mới→cũ; FE tự đảo lại để hiển thị cũ→mới).
export const getClanMessages = (
  clanId: string,
  pageNumber = 1,
  pageSize = 30
) => {
  return API.get<ClanMessage[]>(
    `/v1/user-service/clanchat/${clanId}/messages`,
    { params: { pageNumber, pageSize } }
  ).then((res) => res.data ?? []);
};
